import React from 'react'
import AgentViewChallenge from '../viewChallenge/AgentViewChallenge'
import DpsSidePanel from '../../base/sidepanel/DpsSidePanel'

const CasevalidationDetails = ({
  sliderstate,
  setSliderstate,
  setPcnNumber,
  setToken,
  pcnNumber,
  token,
  handleViewCaseInfo,
  handleCheckNumberOfNotes,
  handleCheckNumberOfCorrespondance,
  addNotesDialogProps = {},
  CancelPcnDialogBox,
  cancelPcnDialogProps = {},
  HoldPcnDialogBox,
  holdPcnDialogProps = {},
  OffHoldPcnDialogBox,
  offHoldPcnDialogProps = {},
  AddNotesDialog,
  setCaseDetails,
  pcnActions,
  setPcnActions,
  viewDetails,
  setViewDetails,
  caseDetails,
  isPcnStatusChanged,
  isViewChallengeEditable,
  setCorrespondanceData,
  correspondanceData,
  isAiraEnabled,
}) => {
  return (
    <div className="casevalidation-details-root">
      <DpsSidePanel
        panStatus={sliderstate}
        onClose={() => {
          setSliderstate(false)
          setPcnNumber('')
          setToken('')
        }}
        onRequestClose={() => {}}
        width={1000}
        sliderHeader={pcnNumber}
        SliderComponent={
          <AgentViewChallenge
            token={token}
            pcnNumber={pcnNumber}
            sliderstate={sliderstate}
            handleViewCaseInfo={handleViewCaseInfo}
            handleCheckNumberOfNotes={handleCheckNumberOfNotes}
            handleCheckNumberOfCorrespondance={
              handleCheckNumberOfCorrespondance
            }
            AddNotesDialog={AddNotesDialog}
            addNotesDialogProps={addNotesDialogProps}
            CancelPcnDialogBox={CancelPcnDialogBox}
            cancelPcnDialogProps={cancelPcnDialogProps}
            HoldPcnDialogBox={HoldPcnDialogBox}
            holdPcnDialogProps={holdPcnDialogProps}
            OffHoldPcnDialogBox={OffHoldPcnDialogBox}
            offHoldPcnDialogProps={offHoldPcnDialogProps}
            setCaseDetails={setCaseDetails}
            viewDetails={viewDetails}
            setViewDetails={setViewDetails}
            pcnActions={pcnActions}
            setPcnActions={setPcnActions}
            caseDetails={caseDetails}
            isPcnStatusChanged={isPcnStatusChanged}
            isViewChallengeEditable={isViewChallengeEditable}
            setCorrespondanceData={setCorrespondanceData}
            correspondanceData={correspondanceData}
            isAiraEnabled={isAiraEnabled}
          />
        }
      />
    </div>
  )
}

export default CasevalidationDetails
